import colorModel from './colorModel.vue';
export default {
  components: {
    colorModel
  },
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    configureList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      form: {},
      colorShow: false
    };
  },
  watch: {
    styleObj: {
      handler() {
        this.form = this.styleObj;
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.form = this.styleObj;
    });
  },
  methods: {
    imgClick(val, id) {
      console.log(val, id);
      this.form.controlsComponentsMark = val;
      this.form.controlsComponentsId = id;
      this.$emit('itemChange', this.form);
    },
    // 是否展示logo
    logoChangeFun(e) {
      this.form.controlsLogoDisplay = e.target.value;
      if (!e.target.value) {
        this.form.controlsLogoExhibitor = 2;
      }
      this.$emit('itemChange', this.form);
    },
    changeFun() {
      this.$emit('itemChange', this.form);
    },
    colorClickFun(val, key) {
      this.colorShow = true;
      this.$nextTick(() => {
        this.$refs.colorRef.init(val, key);
      });
    },
    colorFun(val, key) {
      this.form[key] = val;
      this.changeFun();
      this.colorShow = false;
    },
    // 后缀去除前后空格
    handleBlurTrim(e) {
      this.form.thirdCompanySuffix = e.target.value.trim();
      this.changeFun();
    }
  }
};